export async function fetchWithTimeout(
  input: RequestInfo | URL,
  init?: RequestInit & { timeoutMs?: number },
): Promise<Response> {
  const { timeoutMs, ...fetchInit } = init ?? {};

  if (timeoutMs === undefined) {
    return fetch(input, fetchInit);
  }

  const signals: AbortSignal[] = [AbortSignal.timeout(timeoutMs)];

  if (fetchInit.signal) {
    signals.push(fetchInit.signal);
  }

  return fetch(input, {
    ...fetchInit,
    signal: AbortSignal.any(signals),
  });
}
